import { AppRouteKey } from '~/core/router/route_types';
import SidebarTooltip from '~/shared/components/side_bar_tooltip';
import { SecureLink } from '~/shared/secure_link';

import { getIconByName } from '../sidebar_icon_mapper';

interface TabLinkProps {
  tab: any;
  className?: string;
  routePath: string;
  isActive: boolean;
  isSidebarOpen: boolean;
  getLabel: (key: string) => string;
  onMobileNavigate?: () => void;
}

export function TabLink({
  tab,
  className,
  routePath,
  isActive,
  isSidebarOpen,
  getLabel,
  onMobileNavigate,
}: TabLinkProps) {
  return (
    <SecureLink
      to={tab.route.key as AppRouteKey}
      onClick={onMobileNavigate}
      className={`top-menu group relative flex h-12 items-center rounded-none py-2 leading-none transition-colors duration-300 ease-in-out hover:bg-primaryDark ${className} ${isActive ? 'bg-primaryDark' : 'bg-transparent'} ${tab.disabled ? 'cursor-not-allowed opacity-50' : ''} ${isSidebarOpen ? 'px-4' : 'px-2'}`}
      aria-label={tab.ariaLabel}
      aria-disabled={tab.disabled}
    >
      {tab.icon && (
        <span
          className={`mr-3 flex-shrink-0 transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'scale-100' : 'translate-x-7 scale-125'} ${isActive ? 'text-primaryDefault' : 'text-neutralExtraLight'}`}
        >
          {getIconByName(tab.icon)}
        </span>
      )}

      <span
        className="z-[] whitespace-nowrap text-white transition-opacity duration-300 ease-in-out"
        style={{ opacity: isSidebarOpen ? 1 : 0 }}
      >
        {getLabel(tab.item_caption_ui)}
      </span>

      {!isSidebarOpen && <SidebarTooltip label={getLabel(tab.item_caption_ui)} />}
    </SecureLink>
  );
}
